import {
    IconFacebook,
    IconInstagram,
    IconLinkedin,
    IconSnapchat,
    IconTiktok,
    IconTwitterX,
    IconYoutube,
    TelegramIcon,
    WhatsappIcon,
} from '@/components/icons/SocialIcons';
import { LocalizedContent } from './localizedContent';

export interface HomeData {
    id: number;
    background_image: string;
    title: LocalizedContent;
    video_link: string;
    description: LocalizedContent;
    slug?: string;
    meta?: {
        en?: {
            title?: string;
            description?: string;
        };
        ar?: {
            title?: string;
            description?: string;
        };
    };

    schema?: {
        en?: {
            title?: string;
            description?: string;
        };
        ar?: {
            title?: string;
            description?: string;
        };
    };
}

// Blog
export interface BlogProps {
    id: number;
    title: LocalizedContent;
    summery: LocalizedContent;
    image: string;
    created_at: string;
    category_id?: number;
    category?: LocalizedContent;
    meta?: MetaData;
    schema?: SchemaData;
    slug?: string;
    other_blogs?: BlogProps[];
}
//  Projects
export interface ProjectsGridProps {
    id: number;
    image: string;
    title: LocalizedContent;
    summery: LocalizedContent;
    category_id: number;
    slug?: LocalizedContent;
    meta?: MetaData;
    schema?: SchemaData;
}

export interface ProjectsProps {
    id: number;
    image: string;
    title: LocalizedContent;
    summery: LocalizedContent;
    category_id: number;
    description: LocalizedContent;
}

// Img Slides
export type Slides = {
    content?: string;
    image?: string;
    video?: string;
};

export type SlidesProps = {
    slides: Slides[] | undefined;
    className?: string;
};

// SeriesHeroes
export type Character = {
    name: string;
    image: string;
    content: string;
};

// Games
export type GamesProps = {
    id: number;
    title: LocalizedContent;
    slides: Slides[] | Record<string, Slides[] | Record<string, Slides>>;
    shots: { image: string }[];
    social: { name: string; links: string }[];
    description: LocalizedContent;
    slider: sliderGameProps[];
    characters: SeriesHeroesProps[];
    meta?: MetaData;
    schema?: SchemaData;
    slug?: LocalizedContent;
};

// AmanApp
export type AppProps = {
    id: number;
    slider: sliderAppProps[];
    characters: SeriesHeroesProps[];
    title: LocalizedContent;
    description: LocalizedContent;
    banner_phone: string;
    slides: Slides[] | Record<string, Slides[] | Record<string, Slides>>;
    project_images: string[];
    shots: {
        image: string;
    }[];
    social: { name: string; links: string }[];
    results: LocalizedContent;
    meta?: MetaData;
    schema?: SchemaData;
    slug?: LocalizedContent;
};

export type sliderAppProps = {
    title: LocalizedContent;
    image: string;
    content: LocalizedContent;
    platforms?: string[];
    google_play_link?: string;
    app_store_link?: string;
};
export type MovieProps = {
    id: number;
    title: LocalizedContent;
    slides: Slides[] | Record<string, Slides[] | Record<string, Slides>>;
    social?: { name: string; links: string }[];
    social_links?: ProjectsSocialLinks[];
    shots?: {
        image: string;
    }[];
    project_images?: string[];
    description: LocalizedContent;
    characters?: SeriesHeroesProps[];
    series_heros?: Record<string, Character[]>;
    meta?: MetaData;
    schema?: SchemaData;
};

export type SeriesHeroesProps = {
    series_heros: Record<string, Character[]>; // كائن بمفاتيح اللغة وقيمها مصفوفة من Character
};

export interface MetaData {
    en?: {
        title?: string;
        description?: string;
    };
    ar?: {
        title?: string;
        description?: string;
    };
}
export interface SchemaData {
    en?: {
        title?: string;
        description?: string;
    };
    ar?: {
        title?: string;
        description?: string;
    };
}

export type sliderGameProps = {
    title: string;
    content: string;
    background: string;
    gamelink: string;
    downloadlink: string;
};

//About
export interface Member {
    image: string;
    name: string;
    content: string;
    // name_ar?: LocalizedContent;
    // content_ar?: LocalizedContent;
}

export interface LocalizedMembers {
    ar?: Member[];
    en?: Member[];
}

export interface AboutProps {
    id: number;
    description: LocalizedContent;
    leader_message: LocalizedContent;
    our_vision: LocalizedContent;
    our_mission: LocalizedContent;
    members: LocalizedMembers;
    slug?: string;
    meta?: MetaData;
    schema?: SchemaData;
}

//Footer
export interface SocialLink {
    link: string;
    platform: string;
}

export interface SliderData {
    id: number;
    description: LocalizedContent;
    image: string;
    title: LocalizedContent;
    social_links: SocialLink[];
}

export interface FooterSocialLinks {
    facebook?: string;
    twitter?: string;
    linkedin?: string;
    instagram?: string;
    youtube?: string;
    tiktok?: string;
    snapchat?: string;
    whatsapp?: string;
}

export interface FooterProps {
    id: number;
    email: string;
    company_logo?: string;
    phone?: string;
    company_name_en?: string;
    company_name_ar?: string;
    social?: FooterSocialLinks;
}

export interface PartnersProps {
    id: number;
    logo: string;
    title: LocalizedContent;
    image: string;
    description: LocalizedContent;
}
export interface PartnersBannerProps {
    id: number;
    logo: string;
    image?: string; // صورة مفردة اختيارية
    images?: string[]; // مصفوفة صور لاختيار أكثر من صورة
    title: LocalizedContent;
    description: LocalizedContent;
}

export type ProjectsSocialLinks = {
    name: string;
    link: string;
};

export type SocialLinksProps = {
    className?: string;
    social?: ProjectsSocialLinks[];
};
export const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
    facebook: IconFacebook,
    twitter: IconTwitterX,
    instagram: IconInstagram,
    linkedin: IconLinkedin,
    youtube: IconYoutube,
    tiktok: IconTiktok,
    snapchat: IconSnapchat,
    whatsapp: WhatsappIcon,
    telegram: TelegramIcon,
};
